<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card v-if="dialog">
				<v-card-title class="text-h6 text-uppercase black--text font-weight-bold">
					<v-spacer></v-spacer>
					<div>Sudah Ditambahkan</div>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" @click="hideDialog" class="mr-n3">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row>
						<v-col cols="12">
							<v-card elevation="0" class="  rounded-lg">
								<v-row class="px-3">
									<v-col cols="4" md="2">
										<v-card outlined width="80" height="80" class="py-2 px-2">
											<v-img :src="data.product.product_image[0]"></v-img>
										</v-card>
									</v-col>
									<v-col cols="8" md="6" class="pl-0 my-auto">
										<div class="font-weight-bold">{{data.product.product_name}}</div>
									</v-col>
									<v-col md="4" class="my-auto">
										<router-link style="text-decoration: none;" :to="{ name: 'cart' }">
											<v-btn @click="hideDialog" depressed color="#1951EF" block class="rounded-lg text-uppercase text-caption font-weight-bold white--text" height="42">Lihat Keranjang</v-btn>
										</router-link>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
export default {
	data () {
		return {
		}
	},
	props: {
		value: Boolean,
		data: Object
	},
	methods: {
		hideDialog() {
			// this.$emit('hideDialog')
			this.dialog = false
		},
	},
	computed: {
		dialog: {
			get () {
				return this.value
			},
			set (value) {
				this.$emit('input', value)
			}
		},
	}
};
</script>